<script>
	import DropDown from "./dropdown.svelte"
	import { afterUpdate } from "svelte"
	import { gsap } from 'gsap'
	import { ScrollTrigger } from 'gsap/ScrollTrigger'
	gsap.registerPlugin(ScrollTrigger)

	const jq = window.$
	let container

	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	var slugShowProject = urlParams.get("project");
	//console.log(slugShowProject);

	let allSectorsLabel = allSectors
	let allGeographiesLabel = allGeographies
	let allFundsLabel = allFunds
	let allStatusesLabel = allStatuses
	let filterByLabel = filterBy
	let noProjectsFoundLabel = noProjectsFound
	let resetLabel = resetL
	let loadingLabel = loading
	let visitTheirWebsiteLabel = visitTheirWebsite
	let readCaseStudyLabel = readCaseStudy

	let projects
	let filteredProjects = []
   const { sectors, geographies, funds, statuses } = projectTaxonomies
	import { sector, geography, fund, status } from "./store.js"
   let activeProject
	// $:console.log(projects)

	//assumes exists
	if(geographies.map(el => el.term_id).includes(83)) {
		// let RoW = geographies.filter(function(el) {
		// 	return el.term_id === 83;
		// })[0]
		// console.log(RoW)

		let idx = geographies.map(el => el.term_id).indexOf(83)
		geographies.push(geographies.splice(idx, 1)[0])
		// console.log(geographies)
		
	}

	let sectorSlug
	sector.subscribe(value => {
		if(value)
			sectorSlug = value.slug;
	});
	let geoSlug
	geography.subscribe(value => {
      if(value)
      geoSlug = value.slug;
	});

	let fundSlug
	fund.subscribe(value => {
      if(value)
      fundSlug = value.slug;
	});
   let statusSlug
   status.subscribe(value => {
      if(value)
         statusSlug = value.slug;
   });

	function reset() {
		// sector.set({})
		sector.set({name: allSectors, slug:null}) 
		geography.set({name: allGeographies, slug:null})
		fund.set({name: allFunds, slug:null})
		status.set({name: allStatuses, slug:null})
	}

	$: {
		if (projects) {
			filteredProjects = projects
				.filter((project) => {
               if (!fundSlug) return true
               if (!project.funds || !project.funds.length) return false
					return project.funds.map(fund => fund.slug).includes(fundSlug)
				})
				.filter((project) => {
               if (!geoSlug) return true
               if (!project.geographies || !project.geographies.length) return false
					return project.geographies.map(geography => geography.slug).includes(geoSlug)
				})
				.filter((project) => {
               if (!sectorSlug) return true
               if (!project.sectors || !project.sectors.length) return false
					return project.sectors.map(sector => sector.slug).includes(sectorSlug)
				})
				.filter((project) => {
               if (!statusSlug) return true
               if (!project.statuses || !project.statuses.length ) return false
					return project.statuses.map(status => status.slug).includes(statusSlug)
				})
		}
	}

	async function getProjects() {
		let frUrl = window.location.href.includes('/fr/') ? '/fr/' : ''
		const res = await fetch(`${frUrl}/wp-json/theme/v1/get-projects`)
		const data = await res.json()

		if (res.ok) {
         projects = data
			activeProject = data.filter(p => p.title.includes(urlParams.get('active'))) //?[0]
			if(activeProject.length) {
				activeProject = activeProject[0]
				//! history.replaceState(null, null, localti)
			}
		} else {
			throw new Error(data.message)
		}
	}

	let promise = getProjects()

	afterUpdate(() => {
      if(filteredProjects.length) {
         gsap.set('.project', {opacity: 0, y: 8, scale: 0.9}) 
         gsap.to('.project', {opacity: 1, duration: 0.65, y: 0, scale:1, stagger: 0.025, ease: 'elastic.out(1.0,0.7)'}) 
      }
   })
	let showOnLoad = true
	let onLoadAnchor
	$: {
		if(showOnLoad && onLoadAnchor) {
			showOnLoad = false
		}
	}
</script>


<div class="projects-wrap">
	<div class="project-filters filter-bar d-flex justify-content-center pr-lg-5">
		<div class="d-lg-flex align-items-center">
			<p class="filter-label"><strong>{filterByLabel}:</strong></p>
         <div class="col-lg px-0 d-md-flex">
            <DropDown items={sectors} zIndex={4} allLabel={allSectorsLabel} store={sector}/>
            <DropDown items={geographies} zIndex={3} allLabel={allGeographiesLabel} store={geography} isGeographies={true} />
            <DropDown items={funds} zIndex={2} allLabel={allFundsLabel} store={fund} isFunds={true} />
            <DropDown items={statuses} zIndex={1} allLabel={allStatusesLabel} store={status}/>
         </div>
      </div>
   </div>
	{#await promise}
		<p style="text-align: center;">{loadingLabel}...</p>
	{:then}
		{#if !filteredProjects.length}
			<p class="no-found">{noProjectsFoundLabel} <span on:click={() => {reset()}}>{resetLabel}</span></p>
		{:else}
			<div class="projects grid-four" bind:this={container}>
				{#each filteredProjects as project}
					<div
						class="project grid-item {project.sectors ? project.sectors[0].slug:""}"
						style="background-image:url({project.img});"
						>
						{#if slugShowProject && slugShowProject.includes(project.title.replace(/\s+/, '-').toLowerCase())}
							<a bind:this={onLoadAnchor} href="#project-popup" class="fillall" data-title={project.title} data-lity on:click={() => activeProject = project}>
								<span class="sr-only">{project.title}</span>
							</a>
						{:else}
							<a href="#project-popup" class="fillall" data-title={project.title} data-lity on:click={() => activeProject = project}>
								<span class="sr-only">{project.title}</span>
							</a>
						{/if}
					</div>
				{/each}
			</div>
		{/if}
	{:catch error}
		<p style="color: red">{error.message}</p>
	{/await}
</div>

<!-- Apply updates to single-team/single-leadership relationships-->
<div id="project-popup" style="background:#fff;" class="lity-hide">
	{#if activeProject }
		<div class="pup-logo-wrap">
			<div
				class="project-logo"
				style="background-image:url({activeProject.popup_logo})"
				></div>
			<div class="project-close-btn" style="cursor:pointer;" data-lity-close>
				<svg data-lity-close width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path data-lity-close fill-rule="evenodd" clip-rule="evenodd" d="M35.0758 9.92417C35.8081 10.6564 35.8081 11.8436 35.0758 12.5758L12.5758 35.0758C11.8436 35.8081 10.6564 35.8081 9.92417 35.0758C9.19194 34.3436 9.19194 33.1564 9.92417 32.4242L32.4242 9.92417C33.1564 9.19194 34.3436 9.19194 35.0758 9.92417Z" fill="black"/>
					<path data-lity-close fill-rule="evenodd" clip-rule="evenodd" d="M9.92417 9.92417C10.6564 9.19194 11.8436 9.19194 12.5758 9.92417L35.0758 32.4242C35.8081 33.1564 35.8081 34.3436 35.0758 35.0758C34.3436 35.8081 33.1564 35.8081 32.4242 35.0758L9.92417 12.5758C9.19194 11.8436 9.19194 10.6564 9.92417 9.92417Z" fill="black"/> 
				</svg>
			</div>
		</div>
		<div class="row">
			<div class="col-12 d-flex flex-column justify-content-center">
				<div class="project-popup-content-wrap">
					<h2>{activeProject.title}</h2>
					{ @html activeProject.content}
					{#if activeProject.website_link}
					<a href="{activeProject.website_link}" 
						class="external-link mb-5" 
						target="_blank" 
						rel="noreferrer"
						style="display: inline-block">{visitTheirWebsiteLabel ? visitTheirWebsiteLabel: 'Visit their website'}</a>

					{/if}
					{#if activeProject.case_study_link}
					<div class="btn-wrap">
						<a href="{activeProject.case_study_link}" class="btn outlined">
							{readCaseStudyLabel ? readCaseStudyLabel : 'Read Case Study'}
							<svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.284668 4.27889L0.284668 6.01519L10.3555 6.00651L8.06565 8.6891L9.11053 9.92188L13.1937 5.13836L9.11053 0.354841L8.06565 1.58762L10.3555 4.27021L0.284668 4.27889Z" fill="#000"/> </svg>
						</a>
					</div>
					{/if}
				</div>
			</div>
			<div class="col-5">
				{#if activeProject.popup_image}
					<!-- <div class="project-popup-img" style={`background-image: url(${activeProject.popup_image ? activeProject.popup_image.sizes.large: null})`}></div> -->
					<img class="project-popup-img" src={`${activeProject.popup_image ? activeProject.popup_image.sizes.large: null}`} alt="" role="presentation" />
				{/if}
			</div>
		</div>
		{#if activeProject.info_points}
		<div class="project-points">
			<div class="d-flex _text-left">
				{#each activeProject.info_points as info}
					<div class="col">
						<p class="popup-info-label">{info.label}</p>
						<p class="popup-info-value">{info.info.split('(')[0]}</p>
					</div>
				{/each}
			</div>
		</div>
		{/if}
	{/if}
</div>
